import { useEffect, useState } from "react";
import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { PutDeliveryAddress } from "../models/IRestaurantDeliveryAddress";
import { City, Town } from "../models/IOrders";
import { getCityList, getCityWithTownList } from "../services/locations";
import { postRestaurantDeliveryAddress } from "../services/restaurant";

function AddRestaurantDeliveryTown(props: { onSave: () => void; restaurant?: IRestaurantDetail }) {
  const [restaurant, setRestaurant] = useState<IRestaurantDetail | null>(null);
  const [putDeliveryAddress, setputDeliveryAddress] = useState<PutDeliveryAddress | null>(null);
  const [cityList, setCityList] = useState<City[]>();
  const [townList, setTownList] = useState<City>();
  const [newTown, setNewTown] = useState<Town>();

  useEffect(() => {
    if (props.restaurant) setRestaurant(props.restaurant);
  }, [props.restaurant]);

  useEffect(() => {}, [putDeliveryAddress]);
  useEffect(() => {}, [cityList]);

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      getCityList().then((response) => {
        if (response.data) setCityList(response.data);
      });
    }
  }, []);

  const handleCityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    getCityWithTownList(event.target.value).then((response) => {
      if (response.data) setTownList(response.data);
    });
  };

  const handleTownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setputDeliveryAddress({
      restourantDeliveryAddressIsEnabled: false,
      restourantId: props.restaurant!.id!,
      townId: event.target.value,
    });
  };

  const AddTown = (event: React.FormEvent) => {
    event.preventDefault();
    if (putDeliveryAddress) {
      postRestaurantDeliveryAddress(putDeliveryAddress)
        .then(() => {})
        .finally(() => props.onSave());
    }
  };

  return (
    <div
      className="p-3 mb-4 rounded-3"
      style={{
        background: '#f8f9fa',
        border: '1.5px solid #e9ecef',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
      }}
    >
      <div className="fw-semibold mb-3" style={{ color: '#444', fontSize: '0.9rem' }}>
        <i className="bi bi-plus-circle-fill text-primary me-2"></i>
        Yeni Teslimat Bölgesi Ekle
      </div>
      <form onSubmit={AddTown}>
        <div className="row g-2 align-items-end">
          <div className="col-md-4">
            <label className="form-label small text-muted fw-semibold mb-1">
              <i className="bi bi-map me-1"></i>Kent
            </label>
            <select
              className="form-select"
              style={{ borderRadius: '10px', border: '1.5px solid #dee2e6' }}
              onChange={handleCityChange}
              required
              defaultValue=""
            >
              <option value="" disabled>Kent seçiniz...</option>
              {cityList?.map((city) => (
                <option key={city.id} value={city.id}>{city.cityNameTr}</option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label small text-muted fw-semibold mb-1">
              <i className="bi bi-geo me-1"></i>Bölge
            </label>
            <select
              className="form-select"
              style={{ borderRadius: '10px', border: '1.5px solid #dee2e6' }}
              onChange={(evt) => {
                setNewTown((prev) => ({ ...prev!, Id: evt.target.value }));
                handleTownChange(evt);
              }}
              required
              defaultValue=""
            >
              <option value="" disabled>Bölge seçiniz...</option>
              {townList?.town?.map((town) => (
                <option key={town.id} value={town.id}>{town.townNameTr}</option>
              ))}
            </select>
          </div>

          <div className="col-md-4">
            <button
              type="submit"
              className="btn btn-primary w-100"
              style={{ borderRadius: '10px', fontWeight: 600, height: '38px' }}
            >
              <i className="bi bi-plus-lg me-1"></i>Ekle
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddRestaurantDeliveryTown;